import React, { useState, useEffect } from 'react';
import './AddProject.css';
import Navbar from './Navbar';
import { API_URL } from './API';
const AddNewProject = ({ onBack, onSubmit }) => {
  const [formData, setFormData] = useState({
    projectName: '',
    startDate: '',
    vendor: '',
    numberOfBlocks: '',
    status: 'Pipelined', 
    client: '',
    location: '',
    quotation: '',
    city: '',
    pincode: ''
  });

  const [isLoading, setIsLoading] = useState(false);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [loadingVendors, setLoadingVendors] = useState(false);
  const [loadingClients, setLoadingClients] = useState(false);

  const statusOptions = ['Pipelined', 'Ongoing', 'Completed', 'Inactive'];

  useEffect(() => {
    fetchVendors();
    fetchClients();
  }, []);

  const fetchVendors = async () => {
    setLoadingVendors(true);
    try {
      const response = await fetch(`${API_URL}/vendors/get_vendor`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        mode: 'cors'
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      
      if (result.status === 'success' && result.data) {
        const vendors = result.data.map(vendor => ({
          id: vendor.vendor_id,
          name: vendor.vendor_name
        }));
        setVendorOptions(vendors);
      } else {
       
        setVendorOptions([]);
      }
    } catch (error) {
      
      
      setVendorOptions([]);
    } finally {
      setLoadingVendors(false);
    }
  };

  const fetchClients = async () => {
    setLoadingClients(true);
    try {
      const response = await fetch(`${API_URL}/clients/get_client` , {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        mode: 'cors'
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      
      if (result.status === 'success' && result.data) {
        const clients = result.data.map(client => ({
          id: client.client_id,
          name: client.client_name
        }));
        setClientOptions(clients);
      } else {
        
        setClientOptions([]);
      }
    } catch (error) {
   
      alert('No clients and vendors');
      setClientOptions([]);
    } finally {
      setLoadingClients(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    if (formData.numberOfBlocks && (isNaN(formData.numberOfBlocks) || parseInt(formData.numberOfBlocks) <= 0)) {
      alert('Number of blocks must be a positive number');
      return;
    }

    if (formData.quotation && (isNaN(formData.quotation) || parseFloat(formData.quotation) <= 0)) {
      alert('Quotation must be a positive number');
      return;
    }

    if (formData.vendor && (isNaN(formData.vendor) || parseInt(formData.vendor) <= 0)) {
      alert('Please select a valid vendor');
      return;
    }

    if (formData.client && (isNaN(formData.client) || parseInt(formData.client) <= 0)) {
      alert('Please select a valid client');
      return;
    }

    setIsLoading(true);

    try {
      const projectData = {
        project_name: formData.projectName.trim(),
        starting_date: formData.startDate,
        vendor_id: formData.vendor ? parseInt(formData.vendor) : null,
        client_id: formData.client ? parseInt(formData.client) : null,
        location: formData.location,
        quotation_in_words: formData.quotation ? `${parseFloat(formData.quotation)} Rupees` : '',
        amount_in_rupees: formData.quotation ? parseFloat(formData.quotation) : null,
        no_of_blocks: formData.numberOfBlocks ? formData.numberOfBlocks.toString() : '', 
        status: formData.status || 'Pipelined' 
      };

      if (formData.city && formData.city.trim()) {
        projectData.city = formData.city.trim();
      }
      if (formData.pincode && formData.pincode.trim()) {
        projectData.pincode = formData.pincode.trim();
      }

     

      const response = await fetch(`${API_URL}/projects/create_update_projects`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST, GET, OPTIONS',
          'Access-Control-Allow-Headers': 'Content-Type, Accept'
        },
        body: JSON.stringify(projectData),
        mode: 'cors' 
      });

      if (!response.ok) {
        let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
        
        try {
          const errorResult = await response.json();
          if (errorResult.message) {
            errorMessage = errorResult.message;
          }
        } catch (jsonError) {
          
        }
        
        throw new Error(errorMessage);
      }

      const result = await response.json();
      

      const formattedProject = {
        id: result.data?.project_id || Date.now(),
        name: formData.projectName,
        blocks: `${formData.numberOfBlocks} Blocks`,
        status: formData.status,
        location: formData.location,
        startDate: formData.startDate,
        vendor: formData.vendor,
        client: formData.client,
        quotation: formData.quotation,
        city: formData.city,
        pincode: formData.pincode
      };

      if (onSubmit) {
        onSubmit(formattedProject);
      }
      
      alert('Project added successfully!');
      
      setFormData({
        projectName: '',
        startDate: '',
        vendor: '',
        numberOfBlocks: '',
        status: 'Pipelined',
        client: '',
        location: '',
        quotation: '',
        city: '',
        pincode: ''
      });
      
      if (onBack) {
        onBack();
      }

    } catch (error) {
     
      
      if (error.name === 'TypeError') {
        if (error.message.includes('fetch')) {
          alert('Network Error: Cannot connect to server.\n\nPlease check:\n1. Backend server is running on ${API_URL}\n2. CORS is properly configured\n3. No firewall blocking the connection');
        } else {
          alert(`Request Error: ${error.message}`);
        }
      } else if (error.message.includes('CORS')) {
        alert('CORS Error: The backend server is not allowing requests from this origin.\n\nPlease ensure CORS is properly configured in your Flask application.');
      } else if (error.message.includes('400')) {
        alert(`Bad Request: ${error.message}\n\nThis usually means the request format is incorrect or required fields are missing.`);
      } else if (error.message.includes('500')) {
        alert('Server Error: Internal server error occurred.\n\nPlease check the backend logs for more details.');
      } else {
        alert(`Failed to save project: ${error.message}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    if (onBack) {
      onBack();
    }
  };

  return (
    <div className="ANP-00">
      <div className="ANP-01">
        <h2 className="ANP-02">
          Add New Project
        </h2>
        
        <div className="ANP-03">
          <div className="ANP-04">
            <div>
              <label className="ANP-05">
                Project Name
              </label>
              <input 
                type="text"
                name="projectName"
                placeholder="Enter Project Name"
                value={formData.projectName}
                onChange={handleInputChange}
                className="ANP-07"
                disabled={isLoading}
              />
            </div>
            <div>
              <label className="ANP-05">
                Start Date
              </label>
              <input 
                type="date"
                name="startDate"
                value={formData.startDate}
                onChange={handleInputChange}
                className="ANP-07"
                disabled={isLoading}
              />
            </div>
          </div>

          <div className="ANP-04">
            <div>
              <label className="ANP-05">
                Vendor Name
              </label>
              <select 
                name="vendor"
                value={formData.vendor}
                onChange={handleInputChange}
                className="ANP-08"
                disabled={isLoading || loadingVendors}
              >
                <option value="">
                  {loadingVendors ? 'Loading vendors...' : 'Select Vendor'}
                </option>
                {vendorOptions.map((vendor) => (
                  <option key={vendor.id} value={vendor.id}>
                    {vendor.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="ANP-05">
                No. Of Blocks
              </label>
              <input 
                type="number"
                name="numberOfBlocks"
                placeholder="Enter Number of Blocks"
                value={formData.numberOfBlocks}
                onChange={handleInputChange}
                className="ANP-07"
                disabled={isLoading}
                min="1"
              />
            </div>
          </div>

          <div className="ANP-04">
            <div>
              <label className="ANP-05">
                Status
              </label>
              <select 
                name="status"
                value={formData.status}
                onChange={handleInputChange}
                className="ANP-08"
                disabled={isLoading}
              >
                <option value="">Select Status</option>
                {statusOptions.map((option, index) => (
                  <option key={index} value={option}>{option}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="ANP-05">
                Client Name
              </label>
              <select 
                name="client"
                value={formData.client}
                onChange={handleInputChange}
                className="ANP-08"
                disabled={isLoading || loadingClients}
              >
                <option value="">
                  {loadingClients ? 'Loading clients...' : 'Select Client'}
                </option>
                {clientOptions.map((client) => (
                  <option key={client.id} value={client.id}>
                    {client.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="ANP-04">
            <div>
              <label className="ANP-05">
                Location
              </label>
              <input 
                type="text"
                name="location"
                placeholder="Enter Location"
                value={formData.location}
                onChange={handleInputChange}
                className="ANP-07"
                disabled={isLoading}
              />
            </div>
            <div>
              <label className="ANP-05">
                Quotation (₹)
              </label>
              <input 
                type="number"
                name="quotation"
                placeholder="Enter Quotation Amount"
                value={formData.quotation}
                onChange={handleInputChange}
                className="ANP-07"
                disabled={isLoading}
                min="0"
                step="0.01"
              />
            </div>
          </div>

          <div className="ANP-04">
            <div>
              <label className="ANP-05">
                City
              </label>
              <input 
                type="text"
                name="city"
                placeholder="Enter City"
                value={formData.city}
                onChange={handleInputChange}
                className="ANP-07"
                disabled={isLoading}
              />
            </div>
            <div>
              <label className="ANP-05">
                Pincode
              </label>
              <input 
                type="text"
                name="pincode"
                placeholder="Enter Pincode"
                value={formData.pincode}
                onChange={handleInputChange}
                className="ANP-07"
                disabled={isLoading}
                pattern="[0-9]{6}"
                maxLength="6"
              />
            </div>
          </div>
        </div>

        <div className="ANP-09">
          <button 
            type="button" 
            onClick={handleBack}
            className="ANP-10"
            disabled={isLoading}
          >
            Back
          </button>
          <button 
            type="button" 
            onClick={handleSubmit}
            className="ANP-11"
            disabled={isLoading}
          >
            {isLoading ? 'Saving...' : 'Submit'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddNewProject;